/* CERJ LALONDE gallery invitation. Newsletter submission stays native to Shopify. */
(() => {
  'use strict';
  const dialog = document.getElementById('clp-gallery-invitation');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  let form = dialog.querySelector('form');
  let video = dialog.querySelector('video');
  let motion = dialog.querySelector('.clp-gi-motion');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const keys = { dismiss: 'clp-gallery-invitation-dismiss-until', subscribed: 'clp-gallery-newsletter-subscribed', pending: 'clp-gallery-invitation-pending' };
  const period = 24 * 60 * 60 * 1000;
  const shared = { shown: 'clp-newsletter-popup-shown-this-session', until: 'clp-newsletter-popup-shown-until' };
  const repeatPolicyKey = 'clp-gallery-invitation-repeat-policy';
  const read = (store, key) => { try { return window[store].getItem(key); } catch (_) { return null; } };
  const write = (store, key, value) => { try { window[store].setItem(key, String(value)); } catch (_) {} };
  const remove = (store, key) => { try { window[store].removeItem(key); } catch (_) {} };
  let previousFocus, previousOverflow, opened = false, userPaused = false, cssReady = false, cssPromise, waitTimer;
  const params = new URLSearchParams(location.search);
  const preview = params.get('gallery_popup') === 'preview';
  const manual = params.get('gallery_popup') === 'open';
  // The welcome popup owns the homepage on every device; the book offer owns every other page.
  const bookLoader = document.getElementById('clp-book-offer-loader');
  const home = bookLoader?.dataset.home === 'true';
  const bookManual = params.get('book_popup') === 'open' || params.get('book_popup') === 'preview';
  if (!preview) {
    // Both invitations share one visit/day cap. Convert legacy expiries only once.
    const legacy = [
      [keys.dismiss, repeatPolicyKey, read('localStorage', repeatPolicyKey) === '3-days' ? 2 : 13],
      ['clp-book-preview-dismiss-until', 'clp-book-preview-repeat-policy', 2],
    ];
    let until = Number(read('localStorage', shared.until)) || 0;
    legacy.forEach(([dismissKey, policyKey, daysToRemove]) => {
      let expiry = Number(read('localStorage', dismissKey)) || 0;
      if (read('localStorage', policyKey) !== 'one-day') {
        if (expiry > 0) { expiry -= daysToRemove * period; write('localStorage', dismissKey, expiry); }
        write('localStorage', policyKey, 'one-day');
      }
      until = Math.max(until, expiry);
    });
    if (until > Date.now()) write('localStorage', shared.until, until);
    if (read('sessionStorage', 'clp-book-preview-shown-this-session') === 'true') write('sessionStorage', shared.shown, 'true');
  }
  const returnFromPopup = (() => {
    const stamp = Number(read('sessionStorage', keys.pending));
    return stamp > 0 && Date.now() - stamp >= 0 && Date.now() - stamp < 10 * 60 * 1000;
  })();
  const hasSuccess = Boolean(form.querySelector('[data-clp-server-success]'));
  const hasError = Boolean(form.querySelector('[data-clp-server-error]'));
  const returning = returnFromPopup && (hasSuccess || hasError);
  if (!preview && !manual && !returning && (!home || bookManual)) return;
  // Any signup or message on either cerjlalonde.com site counts (cookie/flag set by clp-book-offer-loader).
  const siteSubscribed = () => read('localStorage', 'clp-site-subscribed') === 'true' || /(?:^|;\s*)(clp_subscribed=1|omnisend-form-[0-9a-f]{24}-filled-at=)/.test(document.cookie) || params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true';
  // Own cap: at most once per visit and once per 24 hours; the book offer no longer blocks it.
  const shownKey = 'clp-gallery-invitation-shown-this-session';
  const suppressed = () => dialog.dataset.subscribed === 'true' || siteSubscribed() || read('localStorage', keys.subscribed) === 'true' || read('localStorage', 'clp-book-preview-confirmed-subscriber') === 'true' || read('sessionStorage', shownKey) === 'true' || Number(read('localStorage', keys.dismiss)) > Date.now() || bookLoader?.dataset.shownThisPage === 'true';
  const campaign = (params.get('utm_source') || '').toLowerCase() === 'omnisend' || params.has('omnisendContactID');

  function styleReady() {
    if (cssReady) return Promise.resolve(true);
    if (cssPromise) return cssPromise;
    cssPromise = new Promise(resolve => {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = dialog.dataset.css;
      link.onload = () => { cssReady = true; resolve(true); };
      link.onerror = () => resolve(false);
      document.head.appendChild(link);
    });
    return cssPromise;
  }
  let sourcePromise;
  const designCacheKey = 'clp-gallery-invitation-return-design';
  function editableDesign() {
    if(sourcePromise)return sourcePromise;
    sourcePromise=(async()=>{
      try {
        let markup;
        if (returning && hasSuccess) {
          // The successful return must not wait for a second design request.
          const cached = JSON.parse(read('sessionStorage', designCacheKey) || 'null');
          remove('sessionStorage', designCacheKey);
          if (!cached || cached.source !== dialog.dataset.source || Date.now() - cached.at > 10 * 60 * 1000) return;
          markup = cached.markup;
        } else {
          const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),6000);
          let response;
          try {response=await fetch(dialog.dataset.source,{credentials:'same-origin',cache:'no-store',signal:controller.signal});}finally{clearTimeout(timeout);}
          if(!response.ok)return;
          markup=await response.text();
        }
        const source=new DOMParser().parseFromString(markup,'text/html');
        const design=source.querySelector('[data-clp-gi-live-source]');
        if(!design?.querySelector('form')||!design.querySelector('[data-gi-email]')||!design.querySelector('button[type="submit"]'))return;
        if (!returning && !preview) write('sessionStorage', designCacheKey, JSON.stringify({source:dialog.dataset.source,at:Date.now(),markup:design.outerHTML}));
        const oldError=form.querySelector('[data-clp-server-error]')?.cloneNode(true);
        const oldEmail=form.querySelector('input[type="email"]')?.value||'';
        video?.pause();
        dialog.replaceChildren(...Array.from(design.children).map(node=>document.importNode(node,true)));
        dialog.style.cssText=design.style.cssText;
        dialog.setAttribute('aria-label',design.getAttribute('aria-label')||'Gallery invitation');
        dialog.removeAttribute('aria-labelledby');
        form=dialog.querySelector('form');video=dialog.querySelector('video');motion=dialog.querySelector('.clp-gi-motion');
        if(oldError)form.prepend(oldError);
        const inputs=Array.from(form.querySelectorAll('[data-gi-email]'));const value=form.querySelector('[data-gi-email-value]');
        inputs.forEach(input=>{input.value=oldEmail;input.required=input===inputs[0];input.addEventListener('input',()=>{value.value=input.value.trim();inputs.forEach(other=>{if(other!==input)other.value=input.value;});});});
        value.value=oldEmail;
        if(returning&&hasSuccess){form.hidden=true;dialog.querySelector('.clp-gi-intro').hidden=true;dialog.querySelector('.clp-gi-success').hidden=false;}
        dialog.querySelectorAll('video').forEach(media=>{media.addEventListener('play',syncMotion);media.addEventListener('pause',syncMotion);media.addEventListener('error',()=>{media.hidden=true;media.closest('.clp-gi-cinema').querySelector('.clp-gi-motion')?.setAttribute('hidden','');});});
      } catch(_) { /* Keep the backed-up native popup available if the editable source cannot load. */ }
    })();return sourcePromise;
  }
  function successHeading() {
    const success=dialog.querySelector('.clp-gi-success');
    if(!success || success.hidden)return;
    const heading=dialog.querySelector('.clp-gi-cinema-copy .clp-gi-radical');
    const label=success.querySelector('.clp-gi-eyebrow');
    if(!heading || !label?.textContent.trim())return;
    heading.textContent=label.textContent.trim();
    heading.style.whiteSpace='normal';
    heading.style.fontSize='clamp(25px, 3.3vw, 40px)';
    heading.style.letterSpacing='.14em';
  }
  function syncMotion() {
    if(!video||!motion)return;
    motion.textContent = video.paused ? '▶' : 'Ⅱ';
    motion.setAttribute('aria-label', video.paused ? dialog.dataset.play : dialog.dataset.pause);
  }
  function play() {
    if (!video || !dialog.open || document.hidden || reduced.matches || userPaused) return;
    video.muted = true;
    if (!video.src) video.src = video.dataset.src;
    video.play().then(syncMotion).catch(syncMotion);
  }
  function busy() {
    if (document.hidden) return true;
    const active = document.activeElement;
    if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return true;
    return Array.from(document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')).some(el => el !== dialog && el.getClientRects().length > 0);
  }
  async function open(force = false) {
    if (opened || dialog.open || (!force && (suppressed() || campaign))) return;
    if (!(returning && hasSuccess) && busy()) { waitTimer = setTimeout(() => open(force), 1000); return; }
    const styling = styleReady();
    await editableDesign();
    if (!await styling) return;
    successHeading();
    if (document.hidden || (!force && suppressed())) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    dialog.querySelectorAll('img[data-src]').forEach(img => { if (!img.src) img.src = img.dataset.src; });
    dialog.querySelectorAll('video').forEach(media=>{media.poster=media.closest('.clp-gi-cinema').querySelector('.clp-gi-poster')?.dataset.src||'';});
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    opened = true;
    if (!preview && !returning) {
      write('sessionStorage', shownKey, 'true');
      write('localStorage', keys.dismiss, Date.now() + period);
    }
    if (returning && hasSuccess) dialog.classList.add('clp-gi-visible');
    else requestAnimationFrame(() => dialog.classList.add('clp-gi-visible'));
    dialog.querySelector('[data-close]')?.focus({ preventScroll: true });
    play();
  }
  function close() {
    if (!dialog.open) return;
    dialog.classList.remove('clp-gi-visible');
    dialog.close();
  }
  dialog.addEventListener('click',event=>{if(event.target.closest('[data-close]'))close();});
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
  });
  dialog.addEventListener('close', () => {
    dialog.querySelectorAll('video').forEach(media=>media.pause());
    document.body.style.overflow = previousOverflow || '';
    // Do not extend the daily cap when dismissed; it starts on actual display.
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  video?.addEventListener('play', syncMotion); video?.addEventListener('pause', syncMotion);
  video?.addEventListener('error', () => { video.hidden = true; if(motion)motion.hidden = true; });
  dialog.addEventListener('click',event=>{
    const button=event.target.closest('.clp-gi-motion');if(!button)return;
    const media=button.closest('.clp-gi-cinema')?.querySelector('video');if(!media)return;
    userPaused=!media.paused;
    if(media.paused){media.muted=true;if(!media.src)media.src=media.dataset.src;media.play().catch(()=>{});button.textContent='Ⅱ';}else{media.pause();button.textContent='▶';}
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) dialog.querySelectorAll('video').forEach(media=>media.pause()); else play(); });
  reduced.addEventListener('change', () => { if (reduced.matches) dialog.querySelectorAll('video').forEach(media=>media.pause()); else play(); });
  let checking = false, allowNative = false;
  const syncEmail = () => {
    const input = Array.from(form.querySelectorAll('[data-gi-email],input[type="email"]')).find(el => el.value.trim());
    const email = input?.value.trim() || '';
    const hidden = form.querySelector('[data-gi-email-value]');
    if (hidden) hidden.value = email;
    return email;
  };
  // Check during email entry and reuse the exact-address result on submit.
  // Memory only: no address or status is persisted, and negative results expire quickly.
  const lookupCache = new Map();
  let warmTimer;
  function lookupSubscriber(email) {
    email=email.trim().toLowerCase();
    const cached=lookupCache.get(email);
    if(cached && cached.expires>Date.now()) return cached.promise;
    const entry={expires:Date.now()+15000};
    entry.promise=(async()=>{
      const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),10000);
      let response;
      try {response=await fetch('https://cerjlalonde.com/wp-json/clp/v1/subscriber-status',{
        method:'POST',credentials:'omit',cache:'no-store',headers:{'Content-Type':'application/json'},body:JSON.stringify({email}),signal:controller.signal
      });}finally{clearTimeout(timer);}
      if(!response.ok)throw new Error('Unavailable');
      const result=await response.json();if(typeof result.subscribed!=='boolean')throw new Error('Invalid response');
      entry.expires=Date.now()+(result.subscribed?60000:5000);
      return result;
    })().catch(error=>{if(lookupCache.get(email)===entry)lookupCache.delete(email);throw error;});
    lookupCache.set(email,entry);
    return entry.promise;
  }
  const warmLookup = event => {
    const input=event.target;
    if(preview || !input.matches?.('[data-gi-email],input[type="email"]'))return;
    clearTimeout(warmTimer);
    if(!input.value.trim() || !input.checkValidity())return;
    const email=input.value.trim();
    const run=()=>{
      dialog.querySelectorAll('.clp-gi-already img[data-src]').forEach(img=>{if(!img.src)img.src=img.dataset.src;});
      lookupSubscriber(email).catch(()=>{});
    };
    if(event.type==='focusout')run();else warmTimer=setTimeout(run,650);
  };
  dialog.addEventListener('input',warmLookup);
  dialog.addEventListener('change',warmLookup);
  dialog.addEventListener('focusout',warmLookup);
  async function checkedSubmit(submitter) {
    if (checking || !form.reportValidity()) return;
    const email = syncEmail();
    clearTimeout(warmTimer);
    if (preview) {
      form.hidden=true;dialog.querySelector('.clp-gi-intro').hidden=true;
      const success=dialog.querySelector('.clp-gi-success');success.hidden=false;successHeading();success.focus();return;
    }
    checking=true;
    const buttons=Array.from(form.querySelectorAll('[type="submit"]'));
    buttons.forEach(el=>el.disabled=true);
    form.setAttribute('aria-busy','true');
    form.querySelector('[data-gi-lookup-error]')?.remove();
    // Dismiss immediately; lookup and native Shopify validation continue.
    close();
    const resume = () => {
      if(dialog.open)return;
      dialog.showModal();
      document.body.style.overflow='hidden';
      dialog.classList.add('clp-gi-visible');
    };
    try {
      const result=await lookupSubscriber(email);
      if(result.subscribed){
        const already=dialog.querySelector('.clp-gi-already');if(!already)throw new Error('Missing design');
        dialog.querySelectorAll('video').forEach(media=>media.pause());
        already.querySelectorAll('img[data-src]').forEach(img=>img.src=img.dataset.src);
        dialog.classList.add('clp-gi-is-already');already.hidden=false;resume();already.focus({preventScroll:true});
        write('localStorage',keys.subscribed,'true');
      }else{
        write('sessionStorage',keys.pending,Date.now());
        buttons.forEach(el=>el.disabled=false);
        allowNative=true;
        // Restart the normal Shopify submission, including Shopify CAPTCHA.
        form.requestSubmit(submitter?.isConnected ? submitter : undefined);
      }
    }catch(_){
      const error=document.createElement('p');error.className='clp-gi-error';error.dataset.giLookupError='';error.setAttribute('role','alert');
      const lang=document.documentElement.lang;
      error.textContent=lang.startsWith('fr')?'La vérification est momentanément indisponible. Veuillez réessayer.':lang.startsWith('zh')?'暂时无法验证，请重试。':'We could not verify your subscription just now. Please try again.';
      form.appendChild(error);
      resume();
    }finally{checking=false;form.removeAttribute('aria-busy');buttons.forEach(el=>el.disabled=false);}
  }
  // Capture before Shopify's document-level CAPTCHA click/submit listeners.
  window.addEventListener('click',event=>{
    const button=event.target.closest?.('button[type="submit"],input[type="submit"]');
    if(!button||button.form!==form||!dialog.open||allowNative)return;
    event.preventDefault();event.stopImmediatePropagation();checkedSubmit(button);
  },true);
  window.addEventListener('submit',event=>{
    if(event.target!==form||allowNative)return;
    event.preventDefault();event.stopImmediatePropagation();checkedSubmit(event.submitter);
  },true);
  window.addEventListener('keydown',event=>{
    if(event.key!=='Enter'||event.target.form!==form||event.target.tagName==='TEXTAREA'||allowNative)return;
    event.preventDefault();event.stopImmediatePropagation();checkedSubmit(form.querySelector('[type="submit"]'));
  },true);
  // Only Shopify's real server success below establishes subscriber status.
  window.addEventListener('storage', event => {
    if ([shared.until, keys.subscribed, 'clp-book-preview-confirmed-subscriber'].includes(event.key) && suppressed() && !preview) clearTimeout(waitTimer);
  });
  if (returning) {
    remove('sessionStorage', keys.pending);
    if (hasSuccess) {
      write('localStorage', keys.subscribed, 'true');
      form.hidden = true;
      dialog.querySelector('.clp-gi-intro').hidden = true;
      dialog.querySelector('.clp-gi-success').hidden = false;
    }
    open(true);
  } else if (preview || manual) {
    open(true);
  } else if (!suppressed() && !campaign) {
    // 5 seconds on every device (Cerj: never sooner).
    waitTimer = setTimeout(() => open(), 5000);
  }
})();
